export const ACCEPTED = 'ACCEPTED'
export const DECLINED = 'DECLINED'
export const NONE = 'PASS'

export default {
    ACCEPTED,
    DECLINED,
    NONE
}